/**
 * Filter item definition interface.
 */
var GridLinkOperator;

(function (GridLinkOperator) {
  GridLinkOperator["And"] = "and";
  GridLinkOperator["Or"] = "or";
})(GridLinkOperator || (GridLinkOperator = {}));

export { GridLinkOperator };